<template>
  <v-container fluid v-if="user">
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare.png')"
          class="mx-auto"
          contain
          max-height="100px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-center">
          CONȚINUTUL MATERIALELOR PUBLICATE PE ACEST SITE NU REPREZINTĂ ÎN MOD OBLIGATORIU POZIȚIA OFICIALĂ A UNIUNII EUROPENE SAU A GUVERNULUI ROMÂNIEI.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title style="justify-content: center" v-if="user">
            Bine ați venit, {{ user.firstName }} {{ user.lastName }}
          </v-card-title>

          <v-card-text>
            <p class="text-body-1 text-center">
              Vă aflați pe platforma electronică a concursului de planuri de afaceri organizat în cadrul proiectului I.S.S. – Întreprinderi sociale de succes. În partea din dreapta sus aveți un meniu pe care îl puteți utiliza pentru a naviga pe această platformă. De asemenea, mai jos aveți un meniu pentru navigarea pe această pagină.
            </p>

            <p class="text-body-1 text-center">
              Pentru orice neclarități, vă rugăm să ne contactați:
            </p>

            <p class="text-body-1 text-center">
              Email: recrutaregt.addwise@gmail.com
            </p>

            <p class="text-center text-h6" v-if="user.punctaj">
              <span class="">Punctaj proiect: </span>
              <span class="primary--text">245 / 300</span>
            </p>

            <v-tabs
              v-model="tab"
              background-color="transparent"
              icons-and-text
              grow>
              <v-tab>
                Date personale
                <v-icon>mdi-account</v-icon>
              </v-tab>
              <v-tab>
                Documentele mele
                <v-icon>mdi-file</v-icon>
              </v-tab>
              <v-tab>
                Evaluările mele
                <v-icon>mdi-folder-edit</v-icon>
              </v-tab>
              <v-tab>
                Contestația mea
                <v-icon>mdi-folder-alert</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <UserDetails />
              </v-tab-item>
              <v-tab-item>
                <MyFiles />
              </v-tab-item>
              <v-tab-item>
                <MyReviews />
              </v-tab-item>
              <v-tab-item>
                <MyAppeals />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/parteneri.png')"
          class="mx-auto"
          contain
          max-height="60px">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserDetails from '@/components/UserDetails.vue'
import MyFiles from '@/components/MyFiles.vue'
import MyReviews from '@/components/MyReviews.vue'
import MyAppeals from '@/components/MyAppeals.vue'

export default {
  name: 'AccountComponent',

  components: { UserDetails, MyFiles, MyReviews, MyAppeals },

  data: () => ({
    tab: null
  }),

  watch: {
    tab (value) {
      this.$store.dispatch('setFilesTab', value)
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    }
  }
}
</script>
